<div>
    <h6 class="text-secondary fw-bold">Consulta de solicitudes de servicio disponibles para agregar información del vehículo</h6>

    <div>
        <br>
        <div class="overflow-auto">
            <table class="table table-bordered text-center">
                <thead>
                    <tr>
                        <th scope="col">ID solicitud</th>
                        <th scope="col">Dependencia</th>
                        <th scope="col">Referente</th>
                        <th scope="col">Fecha solicitud del servicio</th>
                        <th scope="col">Fecha de prestación del servicio</th>
                        <th scope="col">Estado</th>
                        <th scope="col">Acciones</th>
                        <th scope="col">Archivo Adjunto</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let data of dataTable">
                        <td>{{data.id}}</td>
                        <td>{{data.vcDependencia}}</td>
                        <td>{{data.vcNombreReferente}}</td>
                        <td>{{data.dtFechaSolicitud}}</td>
                        <td>{{data.dtFechaPrestacionServicio}}</td>
                        <td>
                            <div class="d-flex align-items-center">
                                <div class="flex-grow-1">
                                    {{data.vcEstado}}
                                </div>

                                <div>
                                    <div class="circle" [style.background-color]="data.vcColorEstado"></div>
                                </div>
                            </div>
                        </td>
                        <td>
                            <button class="btn btn-outline-secondary btn-sm" [routerLink]="['/gestion-solicitud-programador/', data.id]">
                                <i class="fa-sharp fa-solid fa-file-lines"></i>
                            </button>
                        </td>
                        <td>
                            <div class="container" *ngIf="data.txArchivoAdjuntoBase64">
                                <button class="btn btn-outline-secondary btn-sm" (click)="descargarArchivo(data.txArchivoAdjuntoBase64, data.id)">
                                    <i class="fa-solid fa-file-pdf"></i>
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>